export const START_GAME = 'START_GAME';
export const GAME = 'GAME'; 
export const END_GAME = 'END_GAME';
export const FETCHING_GAME = 'FETCHING_GAME';
